












import { Component, Vue, Emit } from 'vue-property-decorator';
import { Job } from '@/@types/LibraryComponent';
import JobCard from './table/JobCard.vue';
import JobDetailModal from '@/components/jobDetail/Base.vue';

interface PageOption {
  count: number;
  max: number;
  min: number;
  current: number;
}

@Component({
  components: {
    JobCard,
    JobDetailModal,
  },
})
export default class JobTable extends Vue {
  private jobs: Array<Job> = require('@/repository/mock/dummyData/job/jobList.json').jobs;
  private jobDetailIsOpen: boolean = false;
  private totalVisible: number = 5;
  private pageOption: PageOption = {
    count: 20,
    max: 5,
    min: 1,
    current: 1,
  };

  private closeJobModal() {
    this.jobDetailIsOpen = false;
  }

  private minimizationJobModal() {
    this.jobDetailIsOpen = false;
  }

  private bookmark(id: string) {
    const job = this.jobs.find((e) => e.id === id);
    if (job) {
      job.isBookmarked = !job.isBookmarked;
    }
  }

  @Emit('open')
  private openDetail(id: string): string {
    return id;
  }
}
